import { ExtractedPageScale, Point2D } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function extractPaths(pdfUrl: string, pageNumber: number): Promise<Point2D[][]> {
  return DesignService.post(`pdfs/pages/${pageNumber}/extractPaths`, { data: { pdfUrl } });
}

export function extractScale(pdfUrl: string): Promise<ExtractedPageScale[]> {
  return DesignService.post('pdfs/extractScale', { data: { pdfUrl } });
}
